var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex" }, [
    _c("div", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.drug.priority,
            expression: "drug.priority",
          },
        ],
        attrs: { type: "radio", id: "p_1", value: "1" },
        domProps: { checked: _vm._q(_vm.drug.priority, "1") },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.drug, "priority", "1")
          },
        },
      }),
      _vm._v(" "),
      _c("label", {
        class: { "btn btn-danger": true, active: _vm.drug.priority == 1 },
        attrs: { for: "p_1" },
      }),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.drug.priority,
            expression: "drug.priority",
          },
        ],
        attrs: { id: "p_2", type: "radio", value: "2" },
        domProps: { checked: _vm._q(_vm.drug.priority, "2") },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.drug, "priority", "2")
          },
        },
      }),
      _vm._v(" "),
      _c("label", {
        class: { "btn btn-warning": true, active: _vm.drug.priority == 2 },
        attrs: { for: "p_2" },
      }),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.drug.priority,
            expression: "drug.priority",
          },
        ],
        attrs: { id: "p_3", type: "radio", value: "3" },
        domProps: { checked: _vm._q(_vm.drug.priority, "3") },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.drug, "priority", "3")
          },
        },
      }),
      _vm._v(" "),
      _c("label", {
        class: { "btn btn-success": true, active: _vm.drug.priority == 3 },
        attrs: { for: "p_3" },
      }),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.drug.priority,
            expression: "drug.priority",
          },
        ],
        attrs: { id: "p_4", type: "radio", value: "4" },
        domProps: { checked: _vm._q(_vm.drug.priority, "4") },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.drug, "priority", "4")
          },
        },
      }),
      _vm._v(" "),
      _c("label", {
        class: { "btn btn-dark": true, active: _vm.drug.priority == 4 },
        attrs: { for: "p_4" },
      }),
    ]),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.drug.priority,
            expression: "drug.priority",
          },
        ],
        attrs: { id: "p_5", type: "radio", value: "5" },
        domProps: { checked: _vm._q(_vm.drug.priority, "5") },
        on: {
          change: function ($event) {
            return _vm.$set(_vm.drug, "priority", "5")
          },
        },
      }),
      _vm._v(" "),
      _c("label", {
        class: { "btn btn-black": true, active: _vm.drug.priority == 5 },
        attrs: { for: "p_5" },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }